import addReferenceUtil from 'modules/training/modules/references/utils/add'

export default function addReferenceCreateReduxUtil (payload) {
  const {
    instance,
    referencePath,
    stateWrapper
  } = payload
  // Add the referencePath to the list of paths referencing the pointer
  const addReferenceObj = addReferenceUtil({
    instance,
    referencePath,
    state: stateWrapper.state
  })
  if (!addReferenceObj) {
    return stateWrapper.state
  }
  return addReferenceObj.state
}
